import * as ScrollMagic from 'scrollmagic';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'

export default {
  ui: {},

  init() {
    // JavaScript to be fired on all pages
    this.bindUI();
    this.bindEvents();
  },

  bindUI() {
		this.ui.win       = window;
    this.ui.backToTop = document.querySelector('.back-to-top');
    this.ui.trigger   = document.querySelector('.page-content');
    this.ui.triggerFooter   = document.querySelector('.content-info');
    this.ui.shareJs   = document.querySelectorAll('.share-js');
    this.ui.moreJs    = document.querySelectorAll('.more-js');
  },
  
  bindEvents() {

    if (document.querySelector('.back-to-top')) {

      // When window is loaded, initBackToTop.
      this.ui.win.addEventListener('load', this.initBackToTop.bind(this));
  
      // When window is resized, initBackToTop.
      this.ui.win.addEventListener('resize', this.initBackToTop.bind(this));

    }

    // For each more, add event.
		for (let i = 0, j = this.ui.shareJs.length; i < j; i++) {
			this.ui.shareJs[i].addEventListener('click', this.shareJs.bind(this));
    }

    // For each more, add event.
		for (let i = 0, j = this.ui.moreJs.length; i < j; i++) {
			this.ui.moreJs[i].addEventListener('click', this.moreJs.bind(this));
    } 
 
	},

	initBackToTop() {
    
    let controller = new ScrollMagic.Controller();
    let self = this;
    let duration = self.ui.trigger.clientHeight -150;

    new ScrollMagic.Scene({
      triggerElement: self.ui.trigger,
      triggerHook: 'onEnter',
      duration: duration,
      offset: '150px',
      // reverse: true,
    })
    .on('enter', function () {

      self.ui.backToTop.classList.add('on');
      self.ui.backToTop.classList.remove('absolute');

    })
    .on('leave', function () {

      self.ui.backToTop.classList.remove('on');

    })
    // .addIndicators({name: 'block'})
    .addTo(controller);
  },

  shareJs(event) {
    event.preventDefault();
    const element = event.currentTarget;
    const dimensions = {facebook: [670, 790], twitter: [550, 400], linkedin: [500, 430]};
    const network = element.dataset.network;
    this.popup(element.dataset.url, 'JSShare', dimensions[network][0], dimensions[network][1]);
  },

  popup(url, title, width, height) {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const systemZoom = screenWidth / window.screen.availWidth;
      const left = (screenWidth - width) / 2 / systemZoom + window.screenLeft;
      const top = (screenHeight - height) / 2 / systemZoom + window.screenTop;
      const newWindow = window.open(url, title, 'width=' + width / systemZoom + ', height=' + height / systemZoom + ', top=' + top + ', left=' + left);
      if (window.focus) {
          newWindow.focus();
      }
  },

  moreJs(event) {
    event.preventDefault();
    const element = event.currentTarget;
    element.classList.toggle('active');
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js